/* ============================================================
   VELUR — Access Gate logic
   Usernames/passwords are set in the theme editor:
   Theme settings → Access Gate → "Usernames & passwords"
   (one per line as  username:password)
   NOTE: this is a soft gate for a members area — the credentials
   live in the page source, so it is not bank-grade security.
   ============================================================ */
(function () {
  var NOTIFY_EMAILS = ['a.nashed@acumenlight.com', 'a.ismail@acumenlight.com'];
  var FORM_ENDPOINT = 'https://script.google.com/macros/s/AKfycbz-5WOEORbnI-CBJtnS8jIYOhxwH14DIKYIdI2ZPJ5UzvhySm7TSB0WP9O5mJqKhrw0IA/exec';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* The members list arrives as SHA-256 digests of "user:password", the
     username lower-cased. It used to arrive as the password itself, printed
     into the source of every page on the site. This function also carried its
     own hardcoded copy as a default, so that is gone too: with no list
     configured there is simply nothing to match, and the sheet endpoint
     remains the real check. */
  function parseHashes(str) {
    return String(str || '').split(',').map(function (h) { return h.trim().toLowerCase(); })
      .filter(function (h) { return /^[0-9a-f]{64}$/.test(h); });
  }
  function sha256Hex(text) {
    if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return ('0' + b.toString(16)).slice(-2);
      }).join('');
    });
  }
  function isAuthed() { try { return sessionStorage.getItem('velur_access') === '1'; } catch (e) { return false; } }
  function setAuthed() { try { sessionStorage.setItem('velur_access', '1'); } catch (e) {} }

  ready(function () {
    var cfg = window.VELUR_GATE || {};
    var modal = document.getElementById('vgate');
    if (!modal) return;

    var credHashes = parseHashes(cfg.userHashes);
    var protectPath = (cfg.link && String(cfg.link).length) ? String(cfg.link) : '/pages/scenders';
    try { protectPath = new URL(protectPath, location.origin).pathname; } catch (e) {}
    var here = location.pathname.replace(/\/$/, '');
    var onProtectedPage = cfg.protect && here === protectPath.replace(/\/$/, '');

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var f = modal.querySelector('[data-vgate-login] input');
      if (f) { try { f.focus(); } catch (e) {} }
    }
    function reveal() {
      document.documentElement.classList.remove('vgate-locked');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    function close() {
      if (document.documentElement.classList.contains('vgate-locked') && !isAuthed()) {
        window.location.href = '/'; // locked page + not signed in → leave
        return;
      }
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    modal.querySelectorAll('[data-vgate-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    /* password show / hide */
    var toggle = modal.querySelector('[data-vgate-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var pass = modal.querySelector('[data-vgate-login] input[name="pass"]');
        if (!pass) return;
        var show = pass.type === 'password';
        pass.type = show ? 'text' : 'password';
        toggle.classList.toggle('is-on', show);
        toggle.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
      });
    }

    /* lock the protected page until the visitor signs in */
    if (onProtectedPage && !isAuthed()) {
      document.documentElement.classList.add('vgate-locked');
      open();
    }

    /* clicking the trigger link (e.g. "Scenders") opens the gate, or goes to the page if already signed in */
    if (cfg.enabled) {
      var trig = String(cfg.trigger || 'Scenders').trim().toLowerCase();
      document.querySelectorAll('a').forEach(function (a) {
        if (a.textContent.trim().toLowerCase() === trig) {
          a.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            if (isAuthed()) { window.location.href = protectPath; }
            else { open(); }
          }, true);
        }
      });
    }

    /* (A) login — checks the Google Sheet (cfg.endpoint) if set, else the local list */
    var loginForm = modal.querySelector('[data-vgate-login]');
    var errEl = modal.querySelector('[data-vgate-error]');
    if (loginForm) {
      var loginBtn = loginForm.querySelector('button[type="submit"]');
      function grant() {
        errEl.textContent = '';
        setAuthed();
        if (document.documentElement.classList.contains('vgate-locked')) { reveal(); }
        else { window.location.href = protectPath; }
      }
      function deny() { errEl.textContent = 'Incorrect username or password.'; }
      /* asynchronous now, because hashing is */
      function localCheck(u, p) {
        if (!credHashes.length) return Promise.resolve(false);
        return sha256Hex(String(u).trim().toLowerCase() + ':' + String(p).trim())
          .then(function (h) { return h.length === 64 && credHashes.indexOf(h) !== -1; })
          .catch(function () { return false; });
      }
      loginForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var u = (loginForm.user.value || '').trim();
        var p = (loginForm.pass.value || '').trim();
        if (cfg.endpoint && String(cfg.endpoint).length) {
          errEl.textContent = 'Checking…';
          if (loginBtn) loginBtn.disabled = true;
          fetch(cfg.endpoint + '?user=' + encodeURIComponent(u) + '&pass=' + encodeURIComponent(p))
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (loginBtn) loginBtn.disabled = false;
              if (res && res.ok) { grant(); } else { deny(); }
            })
            .catch(function () {
              if (loginBtn) loginBtn.disabled = false;
              localCheck(u, p).then(function (ok) {
                if (ok) { grant(); } else { errEl.textContent = 'Could not verify — please try again.'; }
              });
            });
        } else {
          localCheck(u, p).then(function (ok) { if (ok) { grant(); } else { deny(); } });
        }
      });
    }

    /* (B) request access */
    var reqForm = modal.querySelector('[data-vgate-request]');
    var statusEl = modal.querySelector('[data-vgate-status]');
    if (reqForm) {
      reqForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var payload = {
          name:  (reqForm.name.value  || '').trim(),
          phone: (reqForm.phone.value || '').trim(),
          email: (reqForm.email.value || '').trim(),
          subject: 'New Access Request — ' + (cfg.trigger || 'Scenders')
        };
        var btn = reqForm.querySelector('button');
        statusEl.style.color = '#21404f';
        statusEl.textContent = 'Sending…';
        btn.disabled = true;

        fetch(FORM_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        }).then(function () {
          statusEl.style.color = '#21404f';
          statusEl.textContent = 'Thank you — we will be in touch soon.';
          reqForm.reset();
          btn.disabled = false;
        }).catch(function () {
          btn.disabled = false;
          var body = 'Name/Project: ' + payload.name +
                     '%0D%0APhone: ' + payload.phone +
                     '%0D%0AEmail: ' + payload.email;
          window.location.href = 'mailto:' + NOTIFY_EMAILS.join(',') +
            '?subject=' + encodeURIComponent(payload.subject) + '&body=' + body;
        });
      });
    }
  });
})();
